import React, { Component } from "react";
import AntdBadge, {BadgeProps} from 'antd/lib/badge';
import 'antd/lib/badge/style';

export default class Badge extends Component<BadgeProps> {
    render() {
        return (
          <AntdBadge {...this.props} />
        )
    }
}



// WEBPACK FOOTER //
// ./src/components/badge/index.tsx